import { useState, useEffect } from 'react';
import Dashboard from './components/Dashboard';
import StandalonePage from './components/StandalonePage';
import { Box, Typography, Container } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { SignInButton } from "./components/SignInButton";
import { loginRequest } from './auth/authConfig';
import { callMsGraph } from './auth/graph';
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';

import { HashRouter, useLocation } from 'react-router-dom';

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#D87D39"
    }
  }
});

const MainContent = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState(null);
  const [accessToken, setAccessToken] = useState(null);
  const [userInitialized, setUserInitialized] = useState(false);

  const location = useLocation();
  const isStandalonePageRoute = location.pathname === '/standalone-chat-interface';

  const InitUser = async (token) => {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL + "actions/init_user", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_token: token
        })
      });
      if (!response.ok) {
        throw new Error('Failed to initialize user');
      }
      const result = await response.json();
      setUserInitialized(true);      
    } catch (error) {
      console.error('Error initializing user:', error);
    }
  };

  const RequestUserData = async () => {
    try {
      const response = await instance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      const graphResponse = await callMsGraph(response.accessToken);
      setGraphData(graphResponse);
      setAccessToken(response.accessToken);
      if (!userInitialized) {
        await InitUser(response.accessToken);
      }
    } catch (error) {
      console.error("Error acquiring token silently:", error);
    }
  };
  
  useEffect(() => {
    if (accounts && accounts.length > 0 && !graphData && !isStandalonePageRoute) {
      RequestUserData();
    }
  }, [accounts, graphData, isStandalonePageRoute]);

  if (isStandalonePageRoute) {
    return <StandalonePage />;
  }

  return (
    <div className="App">
      <AuthenticatedTemplate>
        {graphData && userInitialized ? (
          <Dashboard user={graphData} accessToken={accessToken} />
        ) : (
          <Typography
            component="h1"
            variant="h4"
            color="inherit"
            gutterBottom
          >
            {graphData && !userInitialized ? "Loading..." : "Loading..."}
            <Box mt={2}>
              <SignInButton />                          
            </Box>  
          </Typography>
        )}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            textAlign: 'center'
          }}
        >
          <Typography
            component="h1"
            variant="h4"
            color="inherit"
            gutterBottom
          >
            Welcome to BUas AI Assistants
          </Typography>   
          <Box mt={2}>
            <SignInButton />                          
          </Box>                
        </Container>
      </UnauthenticatedTemplate>
    </div>
  );
};

function App() {
  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <HashRouter>
        <MainContent />
      </HashRouter>
    </ThemeProvider>    
  );
}

export default App;
